import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API_BASE, HOURS } from "@/content";

const defaultSettings = {
  hours: HOURS,
  announcement: { text: "", link: "", active: false },
};

const SettingsContext = createContext({ ...defaultSettings, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);

  const refresh = useCallback(() => {
    axios
      .get(`${API_BASE}/settings`)
      .then((res) => {
        const data = res.data || {};
        setSettings({
          hours: Array.isArray(data.hours) && data.hours.length ? data.hours : HOURS,
          announcement: data.announcement || defaultSettings.announcement,
        });
      })
      .catch(() => setSettings(defaultSettings));
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ ...settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
